import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerServiceService } from '../customer-service.service';

@Component({
  selector: 'app-lr-update',
  templateUrl: './lr-update.component.html',
  styleUrls: ['./lr-update.component.css']
})
export class LrUpdateComponent implements OnInit {

  lrForm!: FormGroup;
  token: any;
  updateMethod: 'eway' | 'manual' = 'manual';
  tripId!: string;
  selectedLR!: any;
  today: string = new Date().toISOString().split('T')[0];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<LrUpdateComponent>,
    private services: CustomerServiceService,
    @Inject(MAT_DIALOG_DATA) public data: {
      items: any;   // full trip
      index: number; // LR index
    }
  ) { }

  ngOnInit(): void {
    this.tripId = this.data.items._id;  //  trip id
    this.selectedLR = this.data.items.elr_details[this.data.index]; // LR object
    this.token = sessionStorage.getItem("token");
    this.buildForm();
    this.prefillFormIfExists();
  }

  prefillFormIfExists(): void {
    if (!this.selectedLR) return;
    this.lrForm.patchValue({
      consignor_name: this.selectedLR.consignor_name || '',
      consignor_address: this.selectedLR.consignor_address || '',
      consignor_city: this.selectedLR.consignor_city || '',
      consignor_pincode: this.selectedLR.consignor_pincode || '',
      consignor_gst_no: this.selectedLR.consignor_gst_no || '',

      consignee_name: this.selectedLR.consignee_name || '',
      consignee_address: this.selectedLR.consignee_address || '',
      consignee_city: this.selectedLR.consignee_city || '',
      consignee_pincode: this.selectedLR.consignee_pincode || '',
      consignee_gst_no: this.selectedLR.consignee_gst_no || '',

      invoice_date: this.selectedLR.invoice_date
        ? this.selectedLR.invoice_date.split('T')[0]
        : '',
      invoice_no: this.selectedLR.invoice_no || '',
      material_name: this.selectedLR.material_name || '',

      eway_bill_no: this.selectedLR.eway_bill_no || '',
      eway_bill_date: this.selectedLR.eway_bill_date
        ? this.selectedLR.eway_bill_date.split('T')[0]
        : ''
    });
  }

  private buildForm(): void {
    this.lrForm = this.fb.group({
      update_method: ['manual', Validators.required],

      // E-way bill
      eway_bill_no: ['', Validators.required],
      eway_bill_date: ['', Validators.required],

      // Consignor
      consignor_name: ['', Validators.required],
      consignor_address: ['', Validators.required],
      consignor_city: ['', Validators.required],
      consignor_pincode: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      consignor_gst_no: ['', [Validators.required, Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],

      // Consignee
      consignee_name: ['', Validators.required],
      consignee_address: ['', Validators.required],
      consignee_city: ['', Validators.required],
      consignee_pincode: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      consignee_gst_no: ['', [Validators.required, Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],

      // Invoice & material
      invoice_date: ['', Validators.required],
      invoice_no: ['', Validators.required],
      material_name: ['', Validators.required]
    });
  }

  updateLR(): void {
    if (this.lrForm.invalid) {
      this.lrForm.markAllAsTouched();
      return;
    }

    const payload = {
      _id: this.selectedLR._id,
      vehicle_number: this.data.items.truck_info[0]?.truck_number,
      ...this.lrForm.value
    };

    this.services.updateELR(this.tripId, payload, this.token).subscribe(
      (response: any) => {
        console.log('LR updated successfully', response.body);
        this.dialogRef.close(true);
      },
      (error: any) => {
        console.error('LR update failed', error);
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }

  onlyNumbers(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
